export enum LEGACY_PAYMENT_METHOD_GATEWAY {
  'tropipay' = 'TPP',
  'transfermovil' = 'TM',
}

export enum PAYMENT_METHOD_ENUM {
  CREDIT_CARD = 'CREDIT_CARD',
  PAYPAL = 'PAYPAL',
  TROPIPAY = 'TROPIPAY',
  BANK_TRANSFER = 'BANK_TRANSFER',
  INTERNAL_WALLET = 'INTERNAL_WALLET',
  CASH_ON_PICK_UP = 'CASH_ON_PICK_UP',
}

export const PAYMENT_METHOD_ENUM_VALUES = Object.values(PAYMENT_METHOD_ENUM);

export enum PAYMENT_METHOD_GATEWAY {
  TROPIPAY = 'tropipay',
  STRIPE = 'stripe',
  PAYPAL = 'paypal',
  ELAVON = 'elavon',
  BILL_POCKET = 'bill-pocket',
  REDSYS = 'redsys',
  DUCAPP = 'ducapp',
  TM = 'transfermovil',
  ENZONA = 'enzona',
  LABERINTO = 'laberinto',
}

export const PAYMENT_METHOD_GATEWAY_VALUES = Object.values(PAYMENT_METHOD_GATEWAY);
